/**
 * Returns the CDN base URL for serving gallery images and other assets.
 * In production, prepends https://cdn.{currenthost}.
 * On localhost, falls back to the lab CDN.
 */
export function getCdnBase() {
	if (typeof window === 'undefined') return 'https://cdn.lab.stthomasarmenianchurch.com';
	const host = window.location.hostname;
	if (host === 'localhost' || host === '127.0.0.1') {
		return 'https://cdn.lab.stthomasarmenianchurch.com';
	}
	return `https://cdn.${host}`;
}

export const SITE = {
	name: 'St. Thomas Armenian Church',
	fullName: 'St. Thomas Armenian Apostolic Church',
	address: '174 Essex Drive, Tenafly, NJ 07670',
	phone: '(201) 567-5446',
	email: 'stthomasarmenianchurch@yahoo.com',
	youtubeChannel: 'https://www.youtube.com/@saintthomasarmenianchurch8805',
	youtubeStreams: 'https://www.youtube.com/@saintthomasarmenianchurch8805/streams',
	donateUrl:
		'https://www.eservicepayments.com/cgi-bin/Vanco_ver3.vps?appver3=wWsk24ZWJSTZKsGd1RMKlg0BDvsSG3VIWQCPJNNxD8upkiY7JlDavDsozUE7KG0nFx2NSo8LdUKGuGuF396vbZYcLqyTMpcMsecVTK87yYMiYnTg5dP4O6rpX5QvPEWlBhHDN59kLZFffwKfYERpQmJ5pgq7LlE4NfFfD8N2g_Y%3D&ver=3',
	bulletinSignup: 'http://eepurl.com/bHErWz',
};
